import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Header from '../../appLayout/header'

export const SlideService = ({title , description , img}) => {
  return (
  <div className="slide-apropos">
      <div className="header-apropos pt-5">
        <Header />
      </div>
      <div className="slide-apropos-container  ">
            <Row className="align-items-center justify-content-center gx-0  h-100 mt-5 mb-5">

          <Col md={6}>
          <h1 className='slide-title mt-5 mb-'>
{title}
          </h1>
            <div className='descri-slide-mobile'>
           
       <p className='text-slide mt-3 mb-3'>{description} </p>
   </div>
       
        
           
          </Col>
          <Col md={6} className='d-flex  justify-content-end px-5'>
                        <img src={img} alt="Consultante digitale"  className='img-fluid mt-5 mb-5'/></Col>
        </Row>
        </div></div>
  )
}
